import React from 'react'
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify'

function SlidingNumber4x4() {
    const [gridItems, setGridItems] = useState([]);

    const [time, setTime] = useState({ ms: 0, s: 0, m: 0 })
    const [interv, setInterv] = useState()
    const [bestTime, setBestTime] = useState({ ms: 0, s: 0, m: 0 })

    useEffect(() => {
        const shuffledNumbers = Array.from({ length: 16 }, (x, i) => i + 1).sort(() => Math.random() - 0.5);
        setGridItems(shuffledNumbers);
        starttimer();
        clearInterval(interv);
    }, []);

    const renderGrid = () => {
        return gridItems.map((item, index) => (
            <div
                key={index}
                className={`font-bold text-2xl text-[#ffffff] ${item === index + 1 ? 'bg-[#44ff66]' : 'bg-[#FF008A]'}
                            } border-solid border-[10px] border-[#276ED8] p-2 m-1 rounded cursor-pointer text-3xl flex justify-center items-center w-[88px] h-[88px]`}
                onClick={() => moveTile({ index, value: item })}>
                <div className='flex justify-center items-center'>{item === 16 ? '' : item}</div>
            </div>
        ));
    };
    // ------------------------------------moving tile logic-----------------------------------

    // console.log(tile.index + "---------");
    // console.log(tile.value);
    // const num16 = tile.value === 16;

    // const num16index = gridItems.findIndex((item) => item === 16)
    // const neighbors = [
    //     num16index - 1, 
    //     num16index + 1, 
    //     num16index - 4, 
    //     num16index + 4  
    // ];
    const moveTile = (clickedTile) => {

        const num16index = gridItems.findIndex((item) => item === 16);
        console.log(clickedTile);
        console.log(num16index);

        const neighbors = [
            num16index - 1,
            num16index + 1,
            num16index - 4,
            num16index + 4
        ];

        if (neighbors.includes(clickedTile.index)) {
            const newGridItems = [...gridItems];
            newGridItems[num16index] = clickedTile.value;
            newGridItems[clickedTile.index] = 16;
            setGridItems(newGridItems);
            const isSorted = newGridItems.every((item, index) => item === index + 1);
            if (isSorted) {
                toast.success('You win!');
            }
            const currentTimeMS = time.m * 60000 + time.s * 1000 + time.ms;
            const bestTimeMS = bestTime.m * 60000 + bestTime.s * 1000 + bestTime.ms;
            if (currentTimeMS < bestTimeMS || bestTimeMS === 0) {
                setBestTime({ ms: time.ms, s: time.s, m: time.m });
            }
        }
    };
    const handleReset = () => {
        const shuffledNumbers = Array.from({ length: 16 }, (x, i) => i + 1).sort(() => Math.random() - 0.5);
        setTime({ ms: 0, s: 0, m: 0 })
        setGridItems(shuffledNumbers)
    }
    // -----------------------------------------------------------------------------

    // ------------------------------------timer and score logic-----------------------------------


    const starttimer = () => {
        setInterv(setInterval(runTimer, 20));
    }


    const runTimer = () => {
        setTime((prevTime) => {
            let updatedMS = prevTime.ms + 1,
                updatedS = prevTime.s,
                updatedM = prevTime.m;
            if (updatedMS === 100) {
                updatedS++;
                updatedMS = 0;
            }
            if (updatedS === 60) {
                updatedM++;
                updatedS = 0;
            }
            return ({ ms: updatedMS, s: updatedS, m: updatedM })
        });
    };

    return (
        <>
            <div className='flex flex-col justify-center items-center h-screen bg-[#111624] '>

                <div className='bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2'>
                    <div className='mx-2'>
                        <h1>{(time.m >= 10 ? time.m : '0' + time.m)}</h1>
                    </div>
                    <p>:</p>
                    <div className='mx-2'>
                        <h1>{(time.s >= 10 ? time.s : "0" + time.s)}</h1>
                    </div>
                    <p>:</p>
                    <div className='mx-2'>
                        <h1>{(time.ms >= 10 ? time.ms : '0' + time.ms)}</h1>
                    </div>
                </div>

                <div className='bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2'>
                    <h1 className='text-[#FF008A]'>Best score = </h1>
                    <div className='mx-2'>
                        <h1>{(bestTime.m >= 10) ? bestTime.m : "0" + bestTime.m}</h1>
                    </div>
                    <p>:</p>
                    <div className='mx-2'>
                        <h1>{(bestTime.s >= 10) ? bestTime.s : "0" + bestTime.s}</h1>
                    </div>
                    <p>:</p>
                    <div className='mx-2'>
                        <h1>{(bestTime.ms >= 10) ? bestTime.ms : "0" + bestTime.ms}</h1>
                    </div>
                </div>

                <div className='grid grid-cols-4 grid-rows-4 '>{renderGrid()}</div>


                <button className='bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2'
                    onClick={handleReset}>
                    Reset
                </button>

                <Link to="/" className='bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2'>
                    Home
                </Link>
            </div>
        </>
    )
}

export default SlidingNumber4x4;
